import React from "react";
import ReturnsAndRefund from "../components/ReturnsAndRefund";
import BreadcrumbTwo from "../components/BreadcrumbTwo";

const ReturnsAndRefundsPage = () => {
  return (
    <>
      <BreadcrumbTwo title="Returns & Refunds" />
      <ReturnsAndRefund />
    </>
  );
};

export default ReturnsAndRefundsPage;